import { createReducer, on } from '@ngrx/store';
import { initialProductCatalogStore } from './product-catalog.store';
import { ProductCatalogActions } from './product-catalog.actions';

export const productCatalogReducer = createReducer(
    initialProductCatalogStore,
    on(ProductCatalogActions.getProductCatalogSuccess, (state, { response }) => ({
        ...state,
        productCatalogs: response,
        error: null,
    })),
    on(ProductCatalogActions.getProductCatalogFailure, (state, { error }) => ({
        ...state,
        error,
    })),

    // ==================== SEARCH AND FILTERS ====================
    on(ProductCatalogActions.filterSearch, (state, { searchTerm }) => ({
        ...state,
        filter: { ...state.filter, searchTerm },
    })),

    on(ProductCatalogActions.filterSort, (state, { sortOption }) => ({
        ...state,
        filter: { ...state.filter, sort: sortOption },
    })),

    on(ProductCatalogActions.filterCatalogs, (state, { catalogId }) => ({
        ...state,
        filter: {
            ...state.filter,
            catalogs: state.filter.catalogs.includes(catalogId)
                ? state.filter.catalogs.filter(id => id !== catalogId)
                : [...state.filter.catalogs, catalogId],
        },
    })),

    on(ProductCatalogActions.filterProductGroups, (state, { groupId }) => ({
        ...state,
        filter: {
            ...state.filter,
            productGroups: state.filter.productGroups.includes(groupId)
                ? state.filter.productGroups.filter(id => id !== groupId)
                : [...state.filter.productGroups, groupId],
        },
    })),

    on(ProductCatalogActions.filterPublishStatus, (state, { publishStatus }) => ({
        ...state,
        filter: { ...state.filter, publishStatus },
    })),

    on(ProductCatalogActions.filterPriceMin, (state, { priceMin }) => ({
        ...state,
        filter: { ...state.filter, priceMin },
    })),

    on(ProductCatalogActions.filterPriceMax, (state, { priceMax }) => ({
        ...state,
        filter: { ...state.filter, priceMax },
    })),

    on(ProductCatalogActions.filterClear, state => ({
        ...state,
        filter: {
            searchTerm: '',
            catalogs: [],
            productGroups: [],
            publishStatus: 'all',
            priceMin: 0,
            priceMax: 0,
            sort: 'price-asc',
        },
    })),
);
